import { jsx as _jsx } from "react/jsx-runtime";
import { useReevoo } from '../../hooks/useReevoo';
const ReevooCustomerExperience = ({ reviewsPerPage }) => {
    const isReevooLoaded = useReevoo();
    return isReevooLoaded ? _jsx("reevoo-embeddable", { type: "brand", "per-page": reviewsPerPage }) : null;
};
export default ReevooCustomerExperience;
